import type { Size } from "../src/types/theme";

export const DEFAULT_SIGN_IN_VALUE = "Sign In";
export const DEFAULT_SIGN_UP_VALUE = "Sign Up";
export const DEFAULT_RESET_PASSWORD_VALUE = "Confirm Password Reset";
export const EMAIL_ADDRESS_PLACEHOLDER_TEXT = "Email Address";
export const PASSWORD_PLACEHOLDER_TEXT = "Password";
export const CONFIRM_PASSWORD_PLACEHOLDER_TEXT = "Confirm Password";
export const SKIP_BUTTON_LABEL = "SKIP FOR NOW";
export const OR_LABEL = "Or";
export const FULL_NAME_PLACEHOLDER_TEXT = "Full Name";
export const COMPANY_NAME_PLACEHOLDER_TEXT = "Company Name";
export const PHONE_NUMBER_PLACEHOLDER_TEXT = "Phone";
export const SUBSCRIBE_NEWSLETTER_LABEL =
  "Subscribe me to the Builtfirst newsletter";
export const EXISTING_ACCOUNT_LABEL = "Already have an account? {{sign_in}}";
export const NO_ACCOUNT_LABEL = "Don't have an account yet? {{sign_up}}";
export const RESET_PASSWORD_LABEL = "Reset Password";
export const RESET_PASSWORD_SUB_LABEL = "";
export const NEW_PASSWORD_PLACEHOLDER_TEXT = "New Password";
export const CONFIRM_NEW_PASSWORD_PLACEHOLDER_TEXT = "Confirm New Password";
export const RESET_PASSWORD_BUTTON_LABEL = "Confirm Password Reset";
export const FORGOT_PASSWORD_LABEL = "Forgot Password";
export const FORGOT_PASSWORD_SUB_LABEL =
  "We've sent {{email}} an email with instructions on how to reset your password.";
export const FORGOT_PASSWORD_BUTTON_LABEL = "Resend password reset email";
export const FORGOT_PASSWORD_BACK_BUTTON_LABEL =
  "Go back to www.builtfirst.com";
export const VERIFY_EMAIL_LABEL = "Please verify your email";
export const VERIFY_EMAIL_SUB_LABEL =
  "Almost there! We've sent a verification link to {{email}}. Verify your email to proceed";
export const VERIFY_EMAIL_BUTTON_LABEL = "Resend verification email";
export const GALLERY_LABEL = "Gallery";
export const HOW_IT_WORKS_LABEL = "How It Works";
export const FEATURES_LABEL = "Features";
export const REVIEWS_LABEL = "Customers Reviews";
export const REVIEWS_EMPTY_STATE_LABEL = "There aren't any reviews";
export const REVIEWS_EMPTY_STATE_SUB_LABEL =
  "Be the first on sharing a review with our community!";
export const REVIEWS_SORT_LABEL = "Sort";
export const REVIEWS_FILTER_LABEL = "Filter";
export const REVIEWS_CLEAR_FILTER_LABEL = "Clear Filters";
export const REVIEWS_BUTTON_LABEL = "Write a Review";
export const REVIEWS_FORM_LABEL = "Share your review";
export const REVIEWS_QUOTE_PLACEHOLDER_TEXT =
  "What do you think about this product or service?";
export const HIGHEST = "Highest";
export const LOWEST = "Lowest";
export const STARS = "Stars";
export const CANCEL_LABEL = "Cancel";
export const CUSTOMERS_LABEL = "Customers Who Use {{seller_name}} today";
export const PRICING_LABEL = "Pricing";
export const REVIEWS_SEND_LABEL = "Post my review";
export const SIMILAR_TO_LABEL = "Similar To {{seller_name}}";
export const SOCIAL_LINKS_LABEL = "Socials";
export const CLAIM_LABEL = "Claim";
export const CLAIM_SUB_LABEL = "Do you work at {{seller_name}}? Claim";
export const CLAIM_BUTTON_LABEL = "Claim Account";
export const LANGUAGES_LABEL = "Languages";
export const HELP_LINKS_LABEL = "Our Resources";
export const SUPPORT_LABEL = "Support";
export const SELLER_NAME_LABEL = "Seller Name:";
export const LISTING_NAME_LABEL = "Listing Name:";
export const CUSTOMER_NAME_LABEL = "Customer Name:";
export const CUSTOMER_NAME_COMPANY_LABEL = "Customer Company Name:";
export const CUSTOMER_EMAIL_ADDRESS_LABEL = "Customer Email Address:";
export const MARKETPLACE_NAME_LABEL = "Marketplace Name:";
export const QUOTE_REQUEST_ID_LABEL = "Quote Request ID";
export const QUOTE_RECIPIENT_LABEL = "Quote Recipient";
export const DATE_SUBMITTED_LABEL = "Date Submitted";
export const SEE_MORE = "See more";
export const SEE_LESS = "See less";
export const SHARE_LABEL_MOBILE = "Share";
export const VISIT_LABEL_MOBILE = "Visit";
export const COPIED_TO_CLIPBOARD = "Copied to clipboard";
export const ENDORSED_BY_LABEL = "Endorsed by";
export const APPLY_LABEL = "Apply";
export const RESET_LABEL = "Reset";
export const QUOTE_ALL_SUBMITTED = "All Submitted Quotes";
export const QUOTE_FORM_SUBMIT = "Submit";
export const QUOTE_FORM_SECTION_TITLE = "Get {{listing_name}} in no time!";
export const QUOTE_PREVIOUS_SUBMITTED_ON_LISTING =
  "Previous {{listing_name}} Quotes";
export const STATUS_PENDING_VERIFICATION =
  "Pending your confirmation. We sent you an email to confirm whether your ready to complete the final step(s) to redeem.";
export const STATUS_PENDING_REVIEW =
  "Pending approval. Expect an email once {{partner_name}} reviews your redemption request.";
export const STATUS_CHECK_YOUR_INBOX =
  "Check your inbox! Instructions to activate your discount have been sent to your email.";
export const CONSENT_HEADER = "Terms and conditions";
export const CONSENT_SESSION_DURATION = 24;
export const CONSENT_CONFIRM_LABEL = "I agree";
export const CONSENT_REJECT_LABEL = "Cancel";
export const CONSENT_REJECT_URL = "";
export const CONSENT_DESCRIPTION = "Add terms and conditions here.";
export const INPUT_VERTICAL_PADDING = 16;
export const INPUT_HORIZONTAL_PADDING = 15;
export const INPUT_PADDING_OFFSET = 1;
export const INPUT_SIZES: Record<Size["size"], number> = {
  extraSmall: 23,
  small: 27,
  medium: 32,
  large: 36,
  extraLarge: 40,
};
export const INPUT_LABEL_POSITIONS: Record<Size["size"], number> = {
  extraSmall: 3,
  small: 5,
  medium: 7,
  large: 8,
  extraLarge: 9,
};
